<template>
  <div>
    <q-dialog v-model="alert" persistent>
      <div class="hris-modal">
        <div class="hris-modal-header">
          <h2 class="hris-modal-title">Please confirm your password!</h2>
          <q-btn icon="fas fa-times" flat round dense class="hris-q-ghost" v-close-popup></q-btn>
        </div>
        <div class="hris-modal-body">
          <q-form ref="vForm" @submit="verifyPassword">
            <q-input outlined dense color="green" v-model="password" type="password" label="Enter your payslip password" lazy-rules :rules="[formRules.required]">
              <template v-slot:prepend>
                <q-icon name="fa fa-key"></q-icon>
              </template>
            </q-input>
            <q-btn unelevated type="submit" class="hris-q-primary" style="height: 46px; width: 100%; margin-top: 18px;" label="Verify"></q-btn>
          </q-form>
        </div>
      </div>
    </q-dialog>
    <q-dialog v-model="spinner" persistent>
      <div class="hris-loading">
        <q-spinner color="green" size="3em"></q-spinner>
      </div>
    </q-dialog>
  </div>
</template>
<script>
import axios from 'axios';
import mixins from '../../mixins';
export default {
  data () {
    return {
      alert:false,
      password:'',
      spinner:false,
      payslipID:'',
      employeeID:'',
      type:'',
      thirteenthMonth:{},
    }
  },

  mounted(){
    this.eventHub.$on('validatePassword', this.confirmPassword);
  },

  methods:{
   verifyPassword: function(){
      this.spinner = true
     axios.create({
         baseURL: this.apiUrl,
         headers: {
           'Authorization': `Bearer ${this.token}`
         }
      }).get(`/payslip/password/validate/${this.userData.employee_id}/${this.password}`)
      .then((res) => {
         if(res.data.status){
            this.alert = false
            this.spinner = false
            if(this.type == 'payslip'){
               this.eventHub.$emit('showPayslip', { stat: true, payslipID: this.payslipID, employeeID: this.employeeID });
            }else{
              this.eventHub.$emit('showthirteenthMonth', { stat: true, thirteenthMonth: this.thirteenthMonth});
           }
         }else{
            this.spinner = false
            this.$q.notify({
              color: 'red-6',
              textColor: 'white',
              icon: 'fa fa-time-circle',
              message: res.data.message
            });
         }
      })


   },

   confirmPassword(payload) {
      this.alert = payload.stat
      this.type = payload.type
      this.employeeID = this.userData.employee_id
      if(payload.type == 'payslip'){
         this.payslipID = payload.payslip.id
      }else{
         this.thirteenthMonth = payload.thirteenthMonth
      }
   },


   }
}
</script>
